// extracted by mini-css-extract-plugin
export default {"oifToaster":"styles_oifToaster__mur60"};